<div class="info-pair-container {{ customClass }}" [class.with-icon]="icon">
  <div class="d-flex align-items-start">
    <!-- Icon (if provided) -->
    @if (icon) {
      <mat-icon class="info-pair-icon text-muted mr-2">
        {{ icon }}
      </mat-icon>
    }

    <!-- Content -->
    <div class="flex-grow-1 min-width-0">
      <!-- Label -->
      <div class="info-pair-label text-muted small">
        {{ label | translate }}
      </div>

      <!-- Value -->
      <div
        class="info-pair-value font-weight-medium"
        [class.text-truncate]="enableEllipsis"
        [matTooltip]="tooltip ?? ''"
        [matTooltipDisabled]="!!tooltip"
        translate
      >
        <ng-content translate></ng-content>
      </div>
    </div>
  </div>
</div>
